import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUpdateBlog } from "./UpdateBlogApi";

const initialState = {
    blog: {},
    isLoading: false,
    isError: false,
    error: ''
}

export const updateBlog = createAsyncThunk("blog/updateBlog", async({id, likes, isSaved}) =>{
    const updatedBlog = await getUpdateBlog({id, likes, isSaved});
    return updatedBlog;
})

const UpdatedBlogSlice = createSlice({
    name: "updateBlog",
    initialState,
    extraReducers: (builder) =>{
        builder
        .addCase(updateBlog.fulfilled, (state,action) =>{
            state.isLoading = false; 
            state.blog = action.payload;
        })
        .addCase(updateBlog.rejected, (state,action) =>{
            state.isLoading = false; 
            state.blog = {};
            state.isError = true;
            state.error = action.error?.message;
        })
    }
})

export default UpdatedBlogSlice.reducer;